import fetch from 'services/request';
import { IApiGetScreensParam, IUpdateStatusScreenBody, IApiCreateScreenRequest, IApiUpdateScreenRequest, IApiCreateNewDeviceRequest } from '../interfaces/api';

export const getDemoData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: { data: [] } });
    }, 1000);
  });
};

const getListScreens = (params: IApiGetScreensParam) => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-screen/list',
    params,
  });
};

const getSummaryStats = () => {
  return fetch({
    method: 'get',
    url: '/api/v1/manage-screen/summary',
  });
};

const updateStatusScreen = (body: IUpdateStatusScreenBody) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-screen/update-status',
    body,
  });
};

const refreshScreen = (screenId: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/manage-screen/refresh/${screenId}`,
  });
};

const deleteScreen = (screenId: string) => {
  return fetch({
    method: 'delete',
    url: `/api/v1/manage-screen/delete/${screenId}`,
  });
};

const createScreen = (body: IApiCreateScreenRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-screen/add-screens',
    body,
  });
};

const getScreenDetail = (screenId: string) => {
  return fetch({
    method: 'get',
    url: `/api/v1/manage-screen/detail/${screenId}`,
  });
};

const checkDeviceByCode = (code: string) => {
  return fetch({
    method: 'post',
    url: `/api/v1/manage-screen/check-device-by-code/${code}`,
  });
};

const updateScreen = (body: IApiUpdateScreenRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-screen/update-screens',
    body,
  });
};

const addNewDevice = (body: IApiCreateNewDeviceRequest) => {
  return fetch({
    method: 'post',
    url: '/api/v1/manage-screen/add-device',
    body,
  });
};

const dashboardApis = {
  getDemoData,
  getListScreens,
  getSummaryStats,
  updateStatusScreen,
  refreshScreen,
  deleteScreen,
  createScreen,
  getScreenDetail,
  checkDeviceByCode,
  updateScreen,
  addNewDevice,
};

export default dashboardApis;
